const MAX_ITEMS_LOGO_FREE_PACKAGING = 3;

export { MAX_ITEMS_LOGO_FREE_PACKAGING };
